import React from "react";

export default function Label({ children, className }) {
  return (
    <label className={`text-xs leading-none p-0 m-0 ${className}`}>
      {children}
    </label>
  );
}
